<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 pt-8 min-h-screen px-4">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700 pb-96">

      <div class="container mx-auto max-w-6xl bg-white p-8 rounded-lg shadow-lg ">

      <h1 class="font-bold text-center text-2xl">Credenciales</h1>
      <h1 class="font-bold text-center text-xl">Por favor complete el formulario para descargar su credencial</h1>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Ingrese su número de documento</label>
            <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
              <InputText v-bind="field" type="numeric"  placeholder="Documento"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="documento" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit" label="REGISTRARME" class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>DESCARGAR CREDENCIAL
          </button>
        </div>

      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';
import HeaderSection from './HeaderSection.vue';

import suiteService, { Acreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { VERIFICADO } from 'qreventos-suite/constantes';

export default defineComponent({
  components: {
    HeaderSection,
    InputText, BlockUI,
    Field, ErrorMessage, Form
  },
  created () {
    document.title = "Nacionales Santander 2026";
  },
  data() {
    return {
      isSubmitting: false,
      formData: {
        documento: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        documento: yup.string().required('Ingrese su documento').min(7, 'Al menos 6 números'),
      });
    }
  },
  methods: {
    async onSubmit() {
      this.isSubmitting = true;

      let acreditado:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.documento) as Acreditado;
      if(!acreditado) {
        this.isSubmitting = false;
        Swal.fire({ title: "¡Atención!",  html: "El acreditado no existe<br/>", icon: "error" });
        return;
      }

      if(acreditado.estadoAcreditado.id != VERIFICADO) {
        this.isSubmitting = false;
        Swal.fire({ title: "¡Atención!",  html: "La acreditación todavía no fue verificada<br/>", icon: "error" });
        return;
      }
			
      try {
        location.href = "https://apps.qreventos.com/credencial/getCredencial?evento=" + suiteConfig.evento + "&hash=" + acreditado.hash;
      } finally {
        this.isSubmitting = false;
      }
    }
  }
});
</script>
